import ResumenMutuo from "./features/liquidacion/components/resumenMutuo";
import { TopBarRouteConfig } from "./layouts/topbar/topBar";
import { TipoFuncionalidad } from "./utils/enums";

export const topBarRoutes: TopBarRouteConfig[] = [
  // {
  //   basePath: '/mutuos',
  //   match: (path: string) => path.startsWith('/mutuos'),
  //   origen:'bandeja-mutuo',    
  //   menus: [
  //     { path: '/mutuos', name: 'Detalle Mutuo', rol: ['1'], active: true },
  //     { path: '/mutuos/anexos-seguros', name: 'Descargar anexo seguros', rol: ['1'] },
  //     { path: '/mutuos/anexos-seguros', name: 'Descargar ficha escrituración', rol: ['1'] },
  //     { path: '/mutuos/anexos-seguros', name: 'Descargar tabla desarrollo', rol: ['1'] },
  //     { path: '/mutuos/anexos-seguros', name: 'Descargar CAE', rol: ['1'] },
  //   ],
  // },
  {
    basePath: '/mutuos',
    match: (path: string) => path.startsWith('/mutuos'),
    origen: 'cartera-mutuos',
    menus: [
      { path: '/mutuos', name: 'Detalle Mutuo', rol: [TipoFuncionalidad.Cartera_ver.toString()], active: true },
      { path: '/mutuos/dividendo', name: 'Dividendos', rol: [TipoFuncionalidad.Cartera_ver.toString()] },
      { path: '/mutuos/liquidacion', name: 'Liquidación', rol: [TipoFuncionalidad.Cartera_liq_ver.toString()] },
      { path: '/mutuos/prepagos', name: 'Prepagos', rol: [TipoFuncionalidad.Cartera_prep_ver.toString()] },
      { name: 'Resumen Mutuo', rol: [TipoFuncionalidad.Cartera_ver.toString()], component: <ResumenMutuo /> }
    ],
  }
];
